
/*
  UXS — RECORD TRANSITION V2
  VOICE 001 / FINAL

  - Reproduce el MP3 aprobado
  - Subtítulos sincronizados con el audio
  - Respeta el silencio entre las frases
  - Espera hasta que termine la voz
  - Después activa la grabación original
  - No modifica VOICE 002 ni el vocoder
*/

(function () {
  "use strict";

  function initialize() {
    const main = document.getElementById("uxs-main");
    const button = document.getElementById("uxs-record");
    const subtitle = document.getElementById(
      "uxs-voice001-subtitles"
    );
    const status = document.getElementById("uxs-status");

    if (!main || !button || !subtitle) return;

    if (main.dataset.recordTransitionReady === "true") {
      return;
    }

    main.dataset.recordTransitionReady = "true";

    // ======================================
    // AUDIO FINAL
    // ======================================

    const AUDIO_URL =
      "https://cdn.shopify.com/s/files/1/0899/2040/5871/files/" +
      "UXS_VOICE001_ALGUIEN_ESTA_ESCUCHANDO_FINAL.mp3";

    // ======================================
    // SUBTÍTULOS
    // ======================================
    // Tiempos iniciales estimados.
    // El avance siempre sigue audio.currentTime.

    const captions = [
      {
        start: 0.20,
        end: 2.25,
        text: "ALGUIEN ESTÁ ESCUCHANDO."
      },
      {
        start: 3.55,
        end: 6.72,
        text: "NO NECESITAS SABER QUIÉN ES."
      }
    ];

    // ======================================
    // ESTADO
    // ======================================

    let deepQuestionReady = false;
    let transitioning = false;
    let completed = false;
    let internalClick = false;
    let animationFrame = null;
    let lastText = "";

    // ======================================
    // REPRODUCTOR INDEPENDIENTE
    // ======================================
    // No reutilizamos el reproductor de
    // la apertura: así sus subtítulos
    // no se mezclan con esta transición.

    const audio = document.createElement("audio");

    audio.id = "uxs-record-transition-player";
    audio.crossOrigin = "anonymous";
    audio.preload = "auto";
    audio.playsInline = true;
    audio.src = AUDIO_URL;
    audio.style.display = "none";

    main.appendChild(audio);

    // ======================================
    // BOTÓN DE REINTENTO
    // ======================================

    const retry = document.createElement("button");

    retry.type = "button";
    retry.id = "uxs-transition-retry";
    retry.textContent = "ACTIVAR SONIDO";

    Object.assign(retry.style, {
      display: "none",
      background: "transparent",
      color: "#ffffff",
      border: "1px solid #ffffff",
      padding: "13px 28px",
      fontFamily: "monospace",
      fontSize: "12px",
      letterSpacing: "2px",
      cursor: "pointer",
      margin: "12px auto"
    });

    subtitle.insertAdjacentElement("afterend", retry);

    // ======================================
    // RENDER DE SUBTÍTULOS
    // ======================================

    function render(text, showCursor) {
      if (text === lastText) return;

      lastText = text;
      subtitle.textContent = text;

      if (text && showCursor) {
        const cursor = document.createElement("span");

        cursor.className = "uxs-cursor";
        cursor.setAttribute("aria-hidden", "true");

        subtitle.appendChild(cursor);
      }
    }

    // ======================================
    // TYPEWRITER SINCRONIZADO
    // ======================================

    function updateSubtitles() {
      const time = audio.currentTime;

      let visible = "";
      let cursor = false;

      for (const scene of captions) {
        if (
          time < scene.start ||
          time > scene.end
        ) {
          continue;
        }

        const duration =
          scene.end - scene.start;

        const elapsed =
          time - scene.start;

        const progress = Math.max(
          0,
          Math.min(
            1,
            elapsed / (duration * 0.85)
          )
        );

        const eased =
          1 - Math.pow(1 - progress, 2);

        const count = Math.max(
          1,
          Math.min(
            scene.text.length,
            Math.ceil(
              eased * scene.text.length
            )
          )
        );

        visible = scene.text.slice(0, count);
        cursor = progress < 1;

        break;
      }

      render(visible, cursor);
    }

    // ======================================
    // ANIMACIÓN
    // ======================================

    function stopAnimation() {
      if (animationFrame !== null) {
        cancelAnimationFrame(animationFrame);
        animationFrame = null;
      }
    }

    function animate() {
      updateSubtitles();

      if (!audio.paused && !audio.ended) {
        animationFrame =
          requestAnimationFrame(animate);
      } else {
        animationFrame = null;
      }
    }

    function startAnimation() {
      stopAnimation();

      animationFrame =
        requestAnimationFrame(animate);
    }

    // ======================================
    // VISIBILIDAD
    // ======================================

    function hideRecordingButton() {
      button.disabled = true;
      button.style.visibility = "hidden";

      if (status) {
        status.style.visibility = "hidden";
      }
    }

    function restoreRecordingButton() {
      button.disabled = false;
      button.style.visibility = "";

      if (status) {
        status.style.visibility = "";
      }
    }

    // ======================================
    // INICIAR GRABACIÓN ORIGINAL
    // ======================================

    function beginRecording() {
      if (completed) return;

      completed = true;
      transitioning = false;

      stopAnimation();

      retry.style.display = "none";
      render("TE ESCUCHO.", false);

      restoreRecordingButton();

      // El botón original conserva el
      // evento de grabación del Liquid.

      internalClick = true;

      try {
        button.click();
      } finally {
        internalClick = false;
      }

      main.dispatchEvent(
        new CustomEvent(
          "uxs:record-transition-ended",
          { bubbles: true }
        )
      );
    }

    // ======================================
    // REPRODUCIR VOICE 001
    // ======================================

    async function playTransition() {
      if (completed) return;

      transitioning = true;

      hideRecordingButton();

      retry.style.display = "none";
      render("", false);

      try {
        if (audio.ended) {
          audio.currentTime = 0;
        }

        await audio.play();

        retry.style.display = "none";
        startAnimation();

      } catch (error) {
        console.warn(
          "UXS Record Transition:",
          error
        );

        retry.textContent =
          error.name === "NotAllowedError"
            ? "ACTIVAR SONIDO"
            : "REINTENTAR AUDIO";

        retry.style.display = "block";
        render("ALGUIEN ESTÁ ESCUCHANDO.", false);
      }
    }

    // ======================================
    // EVENTOS DE AUDIO
    // ======================================

    audio.addEventListener("playing", () => {
      retry.style.display = "none";
      startAnimation();
    });

    audio.addEventListener("pause", () => {
      stopAnimation();
    });

    audio.addEventListener("ended", () => {
      // Solamente cuando termina el MP3
      // permitimos activar el micrófono.

      beginRecording();
    });

    audio.addEventListener("error", () => {
      console.error(
        "UXS: error al cargar VOICE 001 final"
      );

      stopAnimation();

      retry.textContent = "REINTENTAR AUDIO";
      retry.style.display = "block";
    });

    retry.addEventListener("click", () => {
      if (audio.error) {
        audio.load();
      }

      playTransition();
    });

    // ======================================
    // INTERCEPTAR EL PRIMER HABLAR
    // ======================================

    button.addEventListener(
      "click",
      function (event) {

        // El clic interno activa
        // el grabador original.

        if (internalClick || completed) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        if (!deepQuestionReady) return;
        if (transitioning) return;

        playTransition();

      },
      true
    );

    // ======================================
    // PREGUNTA PROFUNDA TERMINADA
    // ======================================

    main.addEventListener(
      "uxs:deep-question-ready",
      function () {
        deepQuestionReady = true;

        if (!completed) {
          button.textContent = "HABLAR";
        }
      }
    );

    // ======================================
    // LIMPIEZA
    // ======================================

    window.addEventListener(
      "pagehide",
      () => {
        stopAnimation();
        audio.pause();
      },
      { once: true }
    );

    console.log(
      "UXS VOICE 001 Record Transition V2 Ready"
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialize
    );
  } else {
    initialize();
  }
})();
